'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'TABS_CONTAINER',
	name: 'Tabs container',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*', '!TAB'],
	category: 'Layout',
	props: [{
		name: 'spaceTabsEvenly',
		inputType: 'checkbox',
		label: 'Space tabs evenly',
		default: false
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'Device layout',
		props: [{
			name: 'accordionOnMobile',
			inputType: 'checkbox',
			label: 'Accordion on mobile',
			default: false
		}, {
			name: 'accordionOnTablet',
			inputType: 'checkbox',
			label: 'Accordion on tablet',
			default: false
		}, {
			name: 'accordionOnDesktop',
			inputType: 'checkbox',
			label: 'Accordion on desktop',
			default: false
		}, {
			name: 'keepTabsOpen',
			inputType: 'checkbox',
			label: 'Keep tabs open',
			default: false
		}]
	})
};